import { memo, useState } from 'react';
import { docGenXapiService } from '../service/docgenXapi';

interface AISummaryFeedbackProps {
  claimNumber: string;
  documentId: string;
}

const AISummaryFeedback = ({ claimNumber, documentId }: AISummaryFeedbackProps) => {
  const [thumbsUpImgSrc, setThumbsUpImgSrc] = useState('assets/images/aiSummaryFeedback/thumbs-up.svg');
  const [thumbsDownImgSrc, setThumbsDownImgSrc] = useState('assets/images/aiSummaryFeedback/thumbs-down.svg');

  const handleThumbsDownClick = () => {
    const body = {
      claimNumber: claimNumber,
      documentId: documentId,
      feedback: 0,
    };
    docGenXapiService.sendAiSummaryFeedback(body);
    setThumbsUpImgSrc('assets/images/aiSummaryFeedback/thumbs-up.svg');
    setThumbsDownImgSrc('assets/images/aiSummaryFeedback/thumbs-down-clicked.svg');
  };

  const handleThumbsUpClick = () => {
    const body = {
      claimNumber: claimNumber,
      documentId: documentId,
      feedback: 1,
    };
    docGenXapiService.sendAiSummaryFeedback(body);
    setThumbsUpImgSrc('assets/images/aiSummaryFeedback/thumbs-up-clicked.svg');
    setThumbsDownImgSrc('assets/images/aiSummaryFeedback/thumbs-down.svg');
  };

  return (
    <div>
      <img
        src={thumbsUpImgSrc}
        alt="thumbs up button"
        width={28}
        onClick={handleThumbsUpClick}
        style={{ marginRight: '2px' }}
      />
      <img src={thumbsDownImgSrc} alt="thumbs down button" width={28} onClick={handleThumbsDownClick} />
    </div>
  );
};

export default memo(AISummaryFeedback);
